import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./style.scss";

const TableSelect = ({ label, selected, options = [], onSelect, className }) => {
  const [current, setCurrent] = useState(selected);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    setCurrent(selected);
  }, [selected]);

  const selectOption = (option, index) => {
    setCurrent(option);

    // only fire callback if option is different
    if (current.label !== option.label) {
      try {
        onSelect(option, index);
      } catch (error) {
        console.error("no callback defined", error);
      }
    }
  };

  const arrowIconClassList = classNames("arrow", {
    open: showDropdown
  });

  const tableSelectClasses = classNames("table-select", className);

  return (
    <div
      className={tableSelectClasses}
      onClick={() => setShowDropdown(!showDropdown)}
      tabIndex={-1}
      onBlurCapture={e => {
        setTimeout(() => setShowDropdown(false), 150);
      }}
    >
      <div className="label">{label}:</div>

      <div className="value">
        <div>{current.label}</div>
        {options?.length > 1 && (
          <span className={arrowIconClassList}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M7 10l5 5 5-5H7z" />
            </svg>
          </span>
        )}
      </div>

      {showDropdown && options?.length > 1 && (
        <div className="options">
          {options.map((option, index) => (
            <div key={option.value} className="option" onClick={() => selectOption(option, index)}>
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

TableSelect.propTypes = {
  selected: PropTypes.shape({
    label: PropTypes.string
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ),
  onSelect: PropTypes.func,
  className: PropTypes.string,
  label: PropTypes.string
};

TableSelect.defaultProps = {
  options: []
};

export default TableSelect;
